import useSetProjectId from '@activities/terms/TermDetailActivity/hooks/useSetProjectId';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import AccountInfo from './components/AccountInfo';
import Main from './components/Main';
import Sidebar from './components/Sidebar';
import Termination from './components/Termination';

const WithdrawManualActivity: ActivityComponentType = () => {
    useSetProjectId();
    return (
        <AppScreen>
            <Main/>
            <Sidebar/>
            <AccountInfo/>
            <Termination/>
        </AppScreen>
    );
};

export default WithdrawManualActivity;
